package app.properties

class Region(var id: String? = null,
             var name: String)